import {search} from './modules/search.js';

search();
